"use strict";

import Dom from "common/Dom";
export const scrollLock = function scrollLock() {
  $.scrollLock(true);
};
export const scrollUnlock = function scrollUnlock() {
  $.scrollLock(false);
};
